export default __webpack_public_path__ + "static/media/background-pokeball.8d0eaef6.png";